import api from './api';

const salesDashboardService = {
  // Get sales dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/sales/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting sales dashboard stats:', error);
      throw error;
    }
  }
};

export default salesDashboardService;
